import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getSchoolCodes = createAsyncThunk<any, any>(
  types.GET_SCHOOL_CODES,
  async ({
    schoolId,
    params,
  }: {
    schoolId: string;
    params: Record<string, any>;
  }) => {
    const codes = await api.getSchoolCodes({ schoolId, params });

    return codes;
  },
);

export const generateCodes = createAsyncThunk<any, any>(
  types.GENERATE_SCHOOL_CODES,
  async (data: any) => {
    const codes = await api.generateSchoolCodes(data);

    return codes;
  },
);
